import React, { useContext } from 'react';

import DeleteExtension from '../component/DeleteExtension';
import HeaderExtension from '../component/HeaderExtension';
import Header from '../component/Header';
import { TableContext } from './provider/Provider';
import {
  CheckType,
  Column,
  HeaderExtensionType,
  Row,
  ShowExtendedDeleteViewProps,
} from '../component/types';
import { DownloadButtonsProps } from '../../download-buttons/DownloadButtons';
import { CardHeaderProps } from '../../../molecules/card-header/CardHeader';
import { ButtonProps } from '../../button';
import SelectedView from './SelectedView';

interface Props<T> {
  rows: T[];
  check: CheckType;
  showExtendedDeleteView: ShowExtendedDeleteViewProps;
  tableColumns: Column<T>[];
  downloadColumns: Column<T>[];
  isManageColumn: boolean;
  headerExtension: HeaderExtensionType;
  header: CardHeaderProps;
  download: DownloadButtonsProps<T>;
  selectButtonLabel: string;
  selectButtonProps: ButtonProps;
  columns: Column<T>[];
}

function TableTopView<T extends Row>({
  tableColumns,
  downloadColumns,
  isManageColumn,
  check,
  headerExtension,
  header,
  download,
  selectButtonLabel,
  showExtendedDeleteView,
  rows,
  selectButtonProps,
  columns,
}: Props<T>) {
  const {
    selectedIdsData,
    deleteBtnText,
    onCheckButtonChange,
    showExtendedDelete,
    setShowExtendedDelete,
    setSelectedIdsData,
  } = useContext(TableContext);

  const onClickDeleteExtensionClose = () => {
    setSelectedIdsData({ selectedIds: [] });

    if (!check?.isHideSelectionView) {
      onCheckButtonChange([]);
      setShowExtendedDelete(false);
    }
  };

  return (
    <>
      {header && (
        <Header
          header={header}
          showExtendedDeleteView={showExtendedDeleteView}
          check={check}
          selectButtonLabel={selectButtonLabel || deleteBtnText}
          selectButtonProps={selectButtonProps}
        />
      )}

      {download || headerExtension ? (
        <HeaderExtension
          headerExtension={headerExtension}
          fileName={download?.fileName}
          columns={
            isManageColumn
              ? download?.columns
                ? downloadColumns
                : tableColumns
              : columns
          }
          rows={download?.rows || rows}
          onClickDownload={download?.onClickDownload}
          isLandscapeOrientation={download?.isLandscapeOrientation}
          downloadLoading={download?.downloadLoading}
        />
      ) : null}

      {!check?.isHideSelectionView && showExtendedDelete ? (
        <DeleteExtension
          onClickDeleteExtensionClose={onClickDeleteExtensionClose}
          showExtendedDeleteView={showExtendedDeleteView}
        />
      ) : null}

      {!check?.isHideSelectionView &&
      !showExtendedDelete &&
      selectedIdsData.selectedIds.length ? (
        <SelectedView
          onClickDeleteExtensionClose={onClickDeleteExtensionClose}
          length={selectedIdsData.selectedIds.length}
        />
      ) : null}
    </>
  );
}

export default TableTopView;
